import { render, staticRenderFns } from "./section_4.vue?vue&type=template&id=0ad0834e&scoped=true&"
import script from "./section_4.vue?vue&type=script&lang=js&"
export * from "./section_4.vue?vue&type=script&lang=js&"
import style0 from "./section_4.vue?vue&type=style&index=0&id=0ad0834e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad0834e",
  null
  
)

component.options.__file = "section_4.vue"
export default component.exports